<template>
<div class="group">
    <div class="nav">
        <div class="nav-title">
            <div class="item" :class="{active: curTitleIdx===k}" v-for='(i,k) in data' :key='k' @click="changeTitle(k, i.key)">{{i.name}}</div>
        </div>
    </div>
    <div class="container">
        <div class="nav-icon-text">
            <i class="active iconfont icon-index-copy"></i>
            <span class="active">{{getIndexData.fixedFieldMap['home']}}</span>
            <i class="iconfont icon-youjiantou"></i>
            <span @click="content=''">{{data[curTitleIdx].name}}</span>
            <template v-if='content'>
                <i class="iconfont icon-youjiantou"></i>
                <span>{{name}}</span>
            </template>
        </div>
        <div class="content" v-if='content' v-html="content">{{content}}</div>
        <transition name="fade" v-else>  
            <router-view :data='renderLs' @detail="detail" />
        </transition>  
    </div>
</div>    
</template>

<script>


import common from '../common'
import {mapGetters} from 'vuex'
export default {
    mixins: [common],
    computed: {
      ...mapGetters(['getIndexData']),
    },
    data: () => ({
        type: 'recruit',
        content: '',
        name: '',
    }),
    watch: {
        '$route.path': function () {
            this.content = ''
        }
    },
    methods: {
        detail (data) {
            this.name = data.position
            console.log(data)
            this.$$$api.recruitDetail({id: data.id}, res => {
                this.content = res.data.data.requirements
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"

.fade-enter-active
    ts(.8s ease-in-out)
.fade-enter
    op(0)

theme = #f7aa05

.group
    ppr()
    mt(-200)
    bg(#fff)
    fs(0)
    min-height 500px
    .container
        container()
        .content
            min-height 350px
            fs(18)
            mt(40)
            text-indent 40px
            lh(30)
        .nav-icon-text
            .active
                c(theme)
            i  
                fs(14)
            span 
                pl(10)
                pr(10)
                fs(14)
                _hover()
    .nav 
        h(45)
        bg(rgba(255,255,255,.4))
        transform translateY(-100%)
        .nav-title
            .item   
                _hover()
                lh(45)
                fs(12)
                ib()
                c(#333)
                pl(20)
                pr(20)
                &:first-child 
                    ml(700)
                &.active 
                    c(#fff)
                    bg(#f7aa05)

</style>



// WEBPACK FOOTER //
// src/components/join/index.vue